(function () {
  'use strict';

  function refreshChipBars() {
    var bars = document.querySelectorAll('.chips-wrapper');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var shouldBeScrolled = window.scrollY > 10;

      /* Rebuild the composited glass layer after a theme change. */
      bar.classList.remove('chips-scrolled');
      void bar.offsetHeight;

      if (shouldBeScrolled) bar.classList.add('chips-scrolled');
    });
  }

  function initChipThemeSync() {
    refreshChipBars();

    var observer = new MutationObserver(function (mutations) {
      var themeChanged = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'data-bs-theme';
      });
      if (!themeChanged) return;

      refreshChipBars();
      window.requestAnimationFrame(refreshChipBars);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-bs-theme']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChipThemeSync, { once: true });
  } else {
    initChipThemeSync();
  }
})();
